// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = require("!!../../../node_modules_linux/css-loader/index.js??ref--8-1!../../../node_modules_linux/postcss-loader/lib/index.js??ref--8-2!../../../node_modules_linux/less-loader/dist/cjs.js??ref--8-3!./common.less");
if(typeof content === 'string') content = [[module.id, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = require("!../../../node_modules_linux/vue-style-loader/lib/addStylesClient.js")("5a7522b4", content, true, {});


//////////////////
// WEBPACK FOOTER
// ./src/assets/css/common.less
// module id = KhYh
// module chunks = 40